function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useContext, useMemo, useState } from 'react';
import ValidateDirtyOnlyContext from '../ValidationForm/ValidateDirtyOnlyContext';
import ValidateOnBlurContext from '../ValidationForm/ValidateOnBlurContext';
import WidgetSizeContext from '../WidgetSizeContext/WidgetSizeContext';
import UniqueFormIdContext from '../ValidationForm/UniqueFormIdContext';
import getDisplayName from '../../getDisplayName';
import { useLabelIcons } from './utils/getLabelIcons';
import useIndentFields from '../IndentFieldsContext/useIndentFields';
function getRequiredIconId(controlId, required) {
  if (typeof required === 'string' || required === true) {
    return "".concat(controlId, "--required");
  }
  return '';
}
function getDisplayLabel(schema, options, defaultLabel) {
  var result = defaultLabel || schema.title;
  if (options && options.title) {
    return Object.assign({}, {
      text: result
    }, options.title);
  }
  return result;
}
function getPlaceholder(fieldUiSchema, defaultPlaceholder) {
  var result = defaultPlaceholder;
  if (!defaultPlaceholder && fieldUiSchema['ui:placeholder']) {
    result = fieldUiSchema['ui:placeholder'];
  }
  return result;
}
export function getInputDescription(help) {
  if (!help) {
    return null;
  }
  var helps = Array.isArray(help) ? help : [help];
  return helps.map(function (value) {
    if (typeof value === 'string' || value.href) {
      return value;
    }
    return {
      i18n: {
        id: value.text
      },
      escape: value.escape
    };
  });
}
export default function wrapSchemaWidget(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    var formId = useContext(UniqueFormIdContext);
    var domId = useMemo(function () {
      return "".concat(props.id).concat(formId);
    }, [props.id]);
    var _useIndentFields = useIndentFields(),
      indentClassName = _useIndentFields.indentClassName;
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDirty = _useState2[0],
      setIsDirty = _useState2[1];
    var auto = props.auto,
      disabled = props.disabled,
      rawErrors = props.rawErrors,
      id = props.id,
      label = props.label,
      placeholder = props.placeholder,
      readonly = props.readonly,
      required = props.required,
      formContext = props.formContext,
      schema = props.schema,
      options = props.options,
      onBlur = props.onBlur,
      onValidateBlur = props.onValidateBlur,
      rest = _objectWithoutProperties(props, ["auto", "disabled", "rawErrors", "id", "label", "placeholder", "readonly", "required", "formContext", "schema", "options", "onBlur", "onValidateBlur"]);
    var handleBlur = useCallback(function (p1, p2) {
      setTimeout(function () {
        var activeElementNameAttr = document.activeElement.name || '';
        if (activeElementNameAttr === p1) {
          return;
        }

        // most likely p1 is event or id; p2 is value
        setIsDirty(true);
        if (onValidateBlur) {
          onValidateBlur(p1, p2);
        }
        if (onBlur) {
          onBlur(p1, p2);
        }
      }, 200);
    }, [setIsDirty, onBlur, onValidateBlur]);
    var fieldId = id.replace(/^_/, '');
    var uiSchema = formContext.uiSchema[fieldId] || {};
    var classNames = uiSchema.classNames;
    var updatedClassNames = auto ? "".concat(auto, " ").concat(classNames) : classNames;
    var _useLabelIcons = useLabelIcons(domId, formContext, null, options),
      labelledBy = _useLabelIcons.labelledBy,
      labelIcons = _useLabelIcons.labelIcons;
    var requiredIconId = getRequiredIconId(domId, required);
    var iconIds = "".concat(labelledBy, " ").concat(requiredIconId);
    var hideLabel = options.label === false;
    var displayLabel = getDisplayLabel(schema, options, label);
    var _placeholder = getPlaceholder(uiSchema, placeholder);
    var _disabled = formContext.isPrintView ? true : disabled;
    var _description = formContext.isPrintView ? null : getInputDescription(options.help);
    return /*#__PURE__*/React.createElement(WidgetSizeContext.Consumer, null, function (widgetSize) {
      return /*#__PURE__*/React.createElement(ValidateDirtyOnlyContext.Consumer, null, function (validateDirtyOnly) {
        return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
          description: _description,
          disabled: _disabled,
          errorMsg: (isDirty || !validateDirtyOnly) && rawErrors && rawErrors[0],
          containerId: "container-".concat(fieldId),
          containerClassName: indentClassName,
          id: domId,
          label: displayLabel.text || displayLabel,
          placeholder: _placeholder,
          labelEscape: displayLabel.escape,
          labelHidden: hideLabel,
          labelIcons: labelIcons,
          iconIds: iconIds,
          readonly: readonly,
          required: required,
          requiredId: requiredIconId,
          size: options.size || widgetSize,
          auto: updatedClassNames,
          formContext: formContext,
          schema: schema,
          options: options
        }, rest, {
          onBlur: handleBlur
        }));
      });
    });
  };
  Wrapped.displayName = "WrapSchemaWidget(".concat(getDisplayName(WrappedComponent), ")");
  return function (props) {
    return /*#__PURE__*/React.createElement(ValidateOnBlurContext.Consumer, null, function (onValidateBlur) {
      return /*#__PURE__*/React.createElement(Wrapped, Object.assign({
        onValidateBlur: onValidateBlur
      }, props));
    });
  };
}